import styled from 'styled-components';
import { Button, Col, Input, Layout, Row, Tabs, Select, Form } from 'antd';
import Checkbox from 'antd/lib/checkbox/Checkbox';

const { TabPane } = Tabs;

export const Wrapper = styled(Layout)`
  .ant-checkbox-inner {
    border-radius: unset;
  }

  .ant-spin-nested-loading {
    width: 100%;
  }
  label {
    color: #707070;
  }
  .ant-form-item-control-input-content {
    display: flex;
    cursor: pointer;
  }
  .ant-select-show-search.ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    cursor: pointer;
  }
  .ant-tabs-nav {
    margin: 0;
  }
  .ant-tabs-nav::before {
    border-bottom: none;
  }
  .ant-input {
    background: #f2f2f2;
  }
  .ant-btn {
    background: #24a95d;
    color: #fff;
    &:hover {
      background: #24a95d;
      color: #fff;
    }
  }
  .drop-active {
    padding: 20px 0 25px 0;
    background: #f2f2f2;
    border-radius: 2px;
    transform: scaleY(0);
    transform-origin: top;
    animation: expand 300ms ease-in-out forwards;
    @keyframes expand {
      to {
        transform: scaleY(1);
      }
    }
  }
  .ant-radio-checked .ant-radio-inner::after {
    background-color: #24a95d;
  }
  .ant-radio-checked .ant-radio-inner {
    border-color: #24a95d;
  }

  .ant-checkbox-inner {
    border: 2px solid #24a95d;
    ::after {
      background-color: #24a95d;
      border-color: #24a95d;
    }
  }
  .ant-checkbox-checked::after {
    border: 1px solid #24a95d;
    border-color: #24a95d;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #24a95d;
    border-color: #24a95d;
  }
  .anticon.anticon-down.ant-dropdown-trigger.ant-transfer-list-header-dropdown {
    display: none;
  }
  .ant-transfer-list-header-title {
    text-align: center;
  }
  .ant-transfer {
    justify-content: center;
    align-self: center;
    width: 100%;
    height: 80%;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
    color: #707070;
    border-radius: 2px;
  }
  .ant-transfer-list-body {
    padding: 16px;
  }
  .ant-transfer-list {
    min-height: 100%;
    min-width: 45.8%;
    background: #ffff;
  }
  .ant-transfer-list-header {
    background-color: transparent;
    color: #24a95d;
    border-bottom: none;
  }
  .ant-transfer-operation {
    margin: 0 18px;
    .ant-btn[disabled] {
      background: #f2f2f2;
      &:hover {
        background: #f2f2f2;
      }
      :nth-last-child(1) {
        background: #f2f2f2;
      }
    }
    .ant-btn-primary {
      background: #24a95d;
      color: #fff;
      border-radius: 0;
    }
  }
  .ant-transfer-list-content {
    li:nth-child(odd) {
      background-color: #f2f2f2;
    }
    ::-webkit-scrollbar {
      width: 5px;
    }
    ::-webkit-scrollbar-track {
      background: #fff;
      margin: 0 !important;
      border-radius: 20px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: #bdbdbd;
      border-radius: 20px;
    }
  }
  .ant-transfer-list-content-item-checked {
    background: transparent;
    &:hover {
      background: #f2f2f2;
    }
  }
  .ant-transfer-list-content-item.ant-transfer-list-content-item-checked {
    &:hover {
      background: #f2f2f2;
    }
  }
  .ant-select-selection-item {
    background: #e0e0e0;
  }
`;
export const StyledTabPane = styled(TabPane)`
  div::-webkit-scrollbar {
    width: 5px;
  }
  div::-webkit-scrollbar-track {
    background: #f4f4f4;
    margin: ${props => !props.mScroll && '138px 0 4px 0'};
    border-radius: 20px;
  }
  div::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 20px;
  }
  display: flex;
  align-items: center;
  min-height: 104px;
  border-radius: 2px;
  flex-direction: column;
  padding: 0 !important;
  > h2 {
    margin: 0;
    font-weight: bold;
    font-size: 32px;
    line-height: 37px;
    color: #001f2a;
  }
  > button {
    width: 200px;
    height: 56px;
    color: #fff;
    border-radius: 0;
    font-weight: 'bold';
    background: #24a95d;
    font-size: 16px;
    line-height: 19px;
    > img {
      margin-right: 10px;
    }
  }
`;
export const StyledCol = styled(Col)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 16px;
  height: 62px;
  border-radius: 2px;
  background: #fff;
  flex-direction: row;
  > h2 {
    margin: 0;
    font-weight: bold;
    font-size: 28px;
    line-height: 37px;
    color: #001f2a;
  }
  > button {
    width: 200px;
    height: 56px;
    color: #fff;
    font-weight: 'bold';
    background: #24a95d;
    font-size: 16px;
    line-height: 19px;
    > img {
      margin-right: 5px;
    }
  }
`;
export const StyledColRow = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 2px;
  height: 28px;
  background: transparent;
  flex-direction: row;
  img {
    margin: 0 5px;
  }
`;
export const Check = styled(Checkbox)`
  position: 'absolute';
`;
export const Fundo = styled.div`
  padding-right: 10px;
  border-radius: 2px;
  background: #fff;
  min-width: 120px;
  margin: 40px 5px 0 5px;
  width: 100%;
`;
export const RowTitle = styled(Col)`
  padding: 15px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #707070;
`;
export const StyledColTitle = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const RowData = styled(Row)`
  font-style: normal;
  color: #707070;
  height: 28px;
  font-size: 12px;
  line-height: 22px;
  font-family: Inter, sans-serif;
  text-align: center;
  .ant-input.ant-input-disabled {
    text-align: center;
    border: none;
    background: transparent;
    color: #000;
    cursor: pointer;
  }
`;
export const RowsForColumn = styled.div`
  cursor: pointer;
  border: ${({ active }) => (active ? '1px solid #24a95d' : '')};
  :nth-child(odd) {
    background-color: #f2f2f2;
  }
`;
export const InputStyled = styled(Input)`
  background: #f2f2f2 !important;
  border-radius: 2px;
  border: none;
  min-width: 0;
  &:focus {
    background: #f2f2f2;
  }
  &:hover {
    background: #f2f2f2;
  }
  ::placeholder {
    color: ${({ placeColor }) => (placeColor ? '#000' : '')};
  }
`;
export const TextArea = styled(Input.TextArea)`
  background: #f2f2f2 !important;
  border-radius: 2px;
  border: none;
  min-width: 0;
  &:focus {
    background: #f2f2f2;
  }
  &:hover {
    background: #f2f2f2;
  }
  ::placeholder {
    color: ${({ placeColor }) => (placeColor ? '#000' : '')};
  }
`;
export const InputMask = styled.input`
  background: #f2f2f2 !important;
  border-radius: 2px;
  border: none;
  min-width: 0;
  &:focus {
    background: #f2f2f2;
  }
  &:hover {
    background: #f2f2f2;
  }
  ::placeholder {
    color: ${({ placeColor }) => (placeColor ? '#000' : '')};
  }
`;
export const AvatarDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  > h1 {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #707070;
  }
  > p {
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #24a95d;
    font-weight: bold;
    margin: 14px 0;
  }
  .ant-upload.ant-upload-select.ant-upload-select-text {
    text-align: center;
  }
`;

export const NameForCustomer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 15px 0 0 0;
  > h1 {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #707070;
    margin: 0;
  }
`;
export const NameForConsult = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 0 15px 0;
  > h1 {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #707070;
    margin: 0;
  }
`;
export const StyledButton = styled(Button)`
  width: 116px;
  height: 40px;
  color: #fff;
  border-radius: 0;
  background: #24a95d !important;
  border: none;
  outline: none;
  font-weight: bold;
  margin: 0 5px;

  &:hover {
    background: #24a95d;
    color: #fff;
    transform: scale(1.05);
  }
  &:focus {
    background: #24a95d;
    color: #fff;
  }
`;
export const WrapperTransfer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  .ant-select-selection-item {
    background: red;
  }
`;

export const StyledButtonCancel = styled(Button)`
  width: 116px;
  height: 40px;
  color: #24a95d !important;
  border-radius: 0;
  background: #fff !important;
  border: solid 1px #24a95d;
  outline: none;
  font-weight: bold;
  margin: 0 5px;
  &:hover {
    background: #fff !important;
    color: #24a95d;
    transform: scale(1.05);
  }
  &:focus {
    background: #fff !important;
    color: #24a95d;
  }
`;

export const ExpandableEditGroup = styled.div``;
export const RowGroupUsers = styled(Row)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #f2f2f2;
  height: 430px;
  margin-top: 70px;
  transform: scaleY(0);
  transform-origin: top;
  animation: expand 300ms ease-in-out forwards;
  @keyframes expand {
    to {
      transform: scaleY(1);
    }
  }
`;

export const SelectFornecedor = styled(Select)`
  .ant-select-selector {
    background-color: #f2f2f2 !important;
    font-weight: normal;
    border: none !important;
    border-radius: 2px !important;
  }
  .ant-select-arrow {
    color: #001f2a;
  }
  .ant-select-selection-item {
    border: none !important;
    background-color: #f2f2f2 !important;
  }
`;

export const StyledForm = styled(Form)`
  .ant-form-item {
    font-weight: 'bold',
    font-size: '14px',
    line-height: '16px',
    color: '#707070',
    margin: '15px 0',
  }
`;
